import { Router } from '@angular/router';
import { of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { NavigationView } from 'app/shared/model/navigation-view';
import { NavigationStore } from 'app/shared/store/navigation.store';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@angular/common/http";
import * as i3 from "../store/navigation.store";
export class NavigationService {
    constructor(router, http, navigationStore) {
        this.router = router;
        this.http = http;
        this.navigationStore = navigationStore;
        this.resourceUrl = environment.apiUrl + '/navigation';
    }
    navigate(element, nextView) {
        if (!nextView) {
            const currentView = this.navigationStore.getCurrentViewSnapshot();
            if (element.typeElement === 'PIECE' && (currentView === NavigationView.DASHBOARD || currentView === NavigationView.ESPACES)) {
                // si on arrive à une pièce depuis la vue "dashboard" ou "données", alors on passe à la vue "ouvrages"
                nextView = NavigationView.OUVRAGES;
            }
            else if (currentView === NavigationView.OUVRAGES) {
                // si on vient de "liste ouvrages", alors on reste dessus
                nextView = NavigationView.OUVRAGES;
            }
            else {
                // sinon on conserve la même vue
                nextView = currentView;
            }
        }
        // utilisation du nextView (enum NavigationViews) dans l'url après modification (minuscule + remplacement des '_' par '-')
        return this.router.navigate(['/bim/' + element.typeElement + '/' + element.id + '/', nextView.toLowerCase().replace(/_/g, '-')]);
    }
    findElementNavigation(id) {
        return this.http.get(`${this.resourceUrl}/elements/${id}`);
    }
    queryElements(searchValue) {
        if (searchValue) {
            const params = new HttpParams().set('searchPhrase', searchValue);
            return this.http.get(`${this.resourceUrl}/elements/query`, { params });
        }
        else {
            return of([]);
        }
    }
}
NavigationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NavigationService_Factory() { return new NavigationService(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.NavigationStore)); }, token: NavigationService, providedIn: "root" });
